import { emptyFunc } from 'common/utils/general.utils'

export const searchPageInterface = { onSearch: emptyFunc, onClose: emptyFunc, translate: emptyFunc }
export const searchInterface = { history: emptyFunc }
